"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "OverflowContainer", {
  enumerable: true,
  get: function get() {
    return _OverflowContainer.OverflowContainer;
  }
});

var _OverflowContainer = require("./OverflowContainer");